const breadCrumb = document.querySelector(".breadcrumb");

// Function to format the price
function formatMoney(amount) {
  return new Intl.NumberFormat("en-AE", {
    style: "currency",
    currency: "AED", // Use 'AED' for UAE Dirham
    minimumFractionDigits: 2, // Ensure two decimal places
    maximumFractionDigits: 2,
  }).format(amount / 100); // Shopify's prices are in cents, so divide by 100
}

function calculatePercentageOff(slashPrice, offerPrice) {
  const percentageOff = ((slashPrice - offerPrice) / slashPrice) * 100;
  return Math.round(percentageOff);
}

// function to update size,price,slash price
function updateDyanamicData(size, price, slashPrice) {
  document.getElementById("selected-size").innerText = size;

  document.getElementById("main-product-price").innerText = formatMoney(price);

  const mainSlashPrice = document.getElementById("main-product-slash-price");
  if (mainSlashPrice !== null) {
    if (slashPrice == 0) {
      document.getElementById("main-product-slash-price").innerText = "";

      document.getElementById("main-product-offer").style = "display: none";
    } else {
      document.getElementById("main-product-slash-price").innerText =
        formatMoney(slashPrice);

      // offer percentage
      const offerPercentage = calculatePercentageOff(slashPrice, price);

      document.getElementById("main-product-offer").style =
        "display: inline-block";
      document.getElementById("main-product-offer").innerText =
        offerPercentage + "% Off";
    }
  }
}

// Function to initialize the variant selection UI
function initializeVariantSelection() {
  const urlParams = new URLSearchParams(window.location.search);
  const variantId = urlParams.get("variant");

  if (variantId) {
    const selectedButton = document.querySelector(
      `.size-button[data-variant-id="${variantId}"]`
    );
    if (selectedButton) {
      const selectedSize = selectedButton.getAttribute("data-size");
      const selectedPrice = selectedButton.getAttribute("data-price"); // variant price
      const selectedSlashPrice =
        selectedButton.getAttribute("data-slash-price"); // variant slash price

      // Update the selected size text,price,slash price
      updateDyanamicData(selectedSize, selectedPrice, selectedSlashPrice);

      // Update the highlight
      document
        .querySelectorAll(".size-button")
        .forEach((btn) => btn.classList.remove("highlight"));
      selectedButton.classList.add("highlight");

      // Update the hidden input
      document.getElementById("variant-id").value = variantId;
    }
  }
}

/* product chart size section */
document.querySelectorAll(".size-button").forEach((button) => {
  if (!button.hasAttribute("disabled")) {
    button.addEventListener("click", function () {
      const selectedSize = this.getAttribute("data-size"); // variant name
      const selectedPrice = this.getAttribute("data-price"); // variant price
      const selectedSlashPrice = this.getAttribute("data-slash-price"); // variant slash price

      // update size, price, slash price
      updateDyanamicData(selectedSize, selectedPrice, selectedSlashPrice);
      // Remove highlight from all buttons and add to selected
      document
        .querySelectorAll(".size-button")
        .forEach((btn) => btn.classList.remove("highlight"));
      this.classList.add("highlight");

      // Update hidden variant ID input
      const variantId = this.getAttribute("data-variant-id");
      document.getElementById("variant-id").value = variantId;

      // Update the URL with the selected variant ID
      const newUrl = new URL(window.location.href);
      newUrl.searchParams.set("variant", variantId);
      window.history.replaceState(null, "", newUrl.toString());

      window.scrollTo(0, 0);
    });
  }
});

// Initialize the variant selection when the page loads
document.addEventListener("DOMContentLoaded", initializeVariantSelection);

/* ________________________________________________________________________ */

// Quantity increment/decrement functionality
const quantityInput = document.querySelector('input[name="quantity"]');
document.querySelector(".negative")?.addEventListener("click", () => {
  if (quantityInput.value > 1) quantityInput.value--;
});
document.querySelector(".positive")?.addEventListener("click", () => {
  quantityInput.value++;
});

// Add to cart form submission with async handling
document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
  form.addEventListener("submit", async (event) => {
    event.preventDefault();
    const variantInput = document.getElementById("variant-id");
    if (!variantInput?.value) {
      variantInput.value = "{{ product.variants.first.id }}";
    }

    try {
      const cartBtn = document.querySelector(".main-cart-btn");

      cartBtn.setAttribute("disabled", true);
      cartBtn.textContent = "Adding to cart...";
      await fetch("/cart/add", {
        method: "POST",
        body: new FormData(form),
      });
      cartBtn.setAttribute("disabled", false);
      cartBtn.textContent = "Add to cart";

      Toastify({
        text: "Product Added to Cart",
        gravity: "bottom",
      }).showToast();
    } catch (error) {
      console.error("Error adding to cart:", error);
      alert("There was an issue adding the item to the cart.");
    }

    // get new cart object
    const res = await fetch("/cart.json");
    const cart = await res.json();

    document.querySelector(".cart-count").innerText = cart.item_count;
    if (document.querySelector(".cart-anim-container span")) {
      document.querySelector(".cart-anim-container span").innerText =
        cart.item_count;
    }
  });
});

/* ---------------------------------------------------------------------------------------------------------- */

/* image thubnail gallery */
document.addEventListener("DOMContentLoaded", function () {
  var swiperThumb = new Swiper(".mySwiperThumb", {
    loop: true,
    spaceBetween: 15,
    slidesPerView: "auto",
    freeMode: true,
    watchSlidesProgress: true,
  });

  var swiperMain = new Swiper(".mySwiper2", {
    loop: true,
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: swiperThumb,
    },
  });

  // Handle variant selection
  const sizeButtons = document.querySelectorAll(".size-button");

  sizeButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const variantId = this.getAttribute("data-variant-id");
      const primaryImageId = window.productVariants[variantId].primary_image_id;

      // Get all slides including cloned slides
      const allSlides = document.querySelectorAll(
        ".mySwiper2 .swiper-slide:not(.swiper-slide-duplicate)"
      );

      // Find the real slide index (not counting duplicates)
      const realIndex = Array.from(allSlides)
        .filter(
          (slide) => slide.getAttribute("data-image-id") === primaryImageId
        )
        .map((slide) => slide.getAttribute("data-swiper-slide-index"))[0];

      if (realIndex >= 0) {
        // Use slideTo with realIndex
        swiperMain.slideToLoop(realIndex, 300); // 300ms animation speed

        // Update thumb swiper position
        swiperThumb.slideToLoop(realIndex, 300);
      }
    });
  });

  const urlParams = new URLSearchParams(window.location.search);
  const variantId = urlParams.get("variant");

  if (variantId) {
    const primaryImageId = window.productVariants[variantId].primary_image_id;

    // Get all slides including cloned slides
    const allSlides = document.querySelectorAll(
      ".mySwiper2 .swiper-slide:not(.swiper-slide-duplicate)"
    );

    // Find the real slide index (not counting duplicates)
    const realIndex = Array.from(allSlides).findIndex(
      (slide) => slide.getAttribute("data-image-id") == primaryImageId
    );

    if (realIndex >= 0) {
      // Use slideTo with realIndex
      swiperMain.slideToLoop(realIndex, 300); // 300ms animation speed

      // Update thumb swiper position
      swiperThumb.slideToLoop(realIndex, 300);
    }
  } else {
    const primaryImageId = Object?.values(window?.productVariants || {})[0]
      ?.primary_image_id;

    // Get all slides including cloned slides
    const allSlides = document.querySelectorAll(
      ".mySwiper2 .swiper-slide:not(.swiper-slide-duplicate)"
    );

    // Find the real slide index (not counting duplicates)
    const realIndex = Array.from(allSlides).findIndex(
      (slide) => slide.getAttribute("data-image-id") == primaryImageId
    );

    if (realIndex >= 0) {
      // Use slideTo with realIndex
      swiperMain.slideToLoop(realIndex, 300); // 300ms animation speed

      // Update thumb swiper position
      swiperThumb.slideToLoop(realIndex, 300);
    }
  }
});

var swiper = new Swiper(".mySwiperBoughtTogether", {
  slidesPerView: "auto",
  spaceBetween: 30,
});

document.addEventListener("DOMContentLoaded", function () {
  // Get all elements
  const productCards = document.querySelectorAll(
    ".product-page-freaquently-bought-together-card"
  );
  const checkboxes = document.querySelectorAll(".fbt-checkbox");
  const totalPriceElement = document.getElementById("fbt-total-price");
  const addToCartButton = document.getElementById("fbt-add-to-cart");
  const initialPrice = parseFloat(
    totalPriceElement?.textContent.replace(/[^0-9.-]+/g, "")
  );

  // Function to update total price
  function updateTotalPrice() {
    let total = initialPrice;
    checkboxes.forEach((checkbox) => {
      if (checkbox.checked) {
        const price = parseFloat(checkbox.getAttribute("data-price")) / 100; // Convert cents to dollars
        total += price;
      }
    });
    totalPriceElement.textContent = formatMoney(total);

    // Update button text based on selection
    const selectedCount = [...checkboxes].filter((cb) => cb.checked).length;
    addToCartButton.textContent =
      selectedCount > 0 ? `Add ${selectedCount + 1} to Cart` : "Add to Cart";
  }

  // Format price to money format
  function formatMoney(amount) {
    return "AED " + amount.toFixed(2);
  }

  // Add click events to product cards and checkboxes
  productCards.forEach((card, index) => {
    const checkbox = checkboxes[index];

    // Make entire card clickable
    card.addEventListener("click", (event) => {
      // Prevent toggle if clicking the checkbox directly
      if (event.target !== checkbox) {
        checkbox.checked = !checkbox.checked;
        updateTotalPrice();
      }
    });

    // Add change event to checkbox
    checkbox.addEventListener("change", (event) => {
      event.stopPropagation(); // Prevent card click from triggering
      updateTotalPrice();
    });
  });

  // Handle add to cart
  if (addToCartButton) {
    addToCartButton.addEventListener("click", async function () {
      const items = [];

      // Add main product
      items.push({
        id: document.querySelector('input[name="id"]').value,
        quantity: 1,
      });

      // Add selected products
      checkboxes.forEach((checkbox) => {
        if (checkbox.checked) {
          const productCard = checkbox.closest(
            ".product-page-freaquently-bought-together-card"
          );
          const variantId = productCard.getAttribute("data-variant-id");
          items.push({
            id: variantId,
            quantity: 1,
          });
        }
      });

      try {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            items: items,
          }),
        });

        if (response.ok) {
          window.location.href = "/cart";
        } else {
          throw new Error("Failed to add items to cart");
        }
      } catch (error) {
        console.error("Error adding items to cart:", error);
        alert(
          "There was an error adding items to your cart. Please try again."
        );
      }
    });
  }
});

/* --------------------------------------------------------- */

/* user review images section */
var swiper = new Swiper(".userImageSlider", {
  freeMode: true,
  spaceBetween: 15,
  slidesPerView: "auto",
});

/* --------------------------------------------------------- */

/* review questions search */
const searchIcon = document.querySelector(".product-page-question-search img");
const searchInput = document.querySelector(
  ".product-page-question-search input"
);

searchIcon?.addEventListener("click", () => {
  searchInput.classList.add("show");

  document.addEventListener("click", (e) => {
    if (!searchIcon.contains(e.target) && !searchInput.contains(e.target)) {
      searchInput.classList.remove("show");
    }
  });
});

/* --------------------------------------------------------- */

// warranty learn more hover
const warrantyHoverContainer = document.querySelector(
  ".product-page-warranty span:nth-child(3)"
);

if (warrantyHoverContainer) {
  warrantyHoverContainer.addEventListener("mouseover", () => {
    document.querySelector(".warranty-desc-container").style.visibility =
      "visible";
  });

  warrantyHoverContainer.addEventListener("mouseout", () => {
    document.querySelector(".warranty-desc-container").style.visibility =
      "hidden";
  });
}
